import {create} from "zustand";

const useIsNotFound = create(set => ({
  isNotFound: false,
  setNotFound: isNotFound =>
    set(() => ({
      isNotFound,
    })),
}));

const setIsNotFound = isNotFound =>
  useIsNotFound.getState().setNotFound(isNotFound);

const withNotFound = (requestPromiseFn, ...args) => {
  setIsNotFound(false);

  return requestPromiseFn(...args).catch(error => {
    if (error.status === 404) {
      setIsNotFound(true);
    }

    return error;
  });
};

export {useIsNotFound, setIsNotFound, withNotFound};
